import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import { useHistory } from "react-router-dom";
import { FilePicker } from "react-file-picker";
import { format } from "date-fns";
import { useSnackbar } from "notistack";
import { appSliderSettingSet } from "application/app.action";
import styles from "./taskInfo.module.scss";
import {
  Button,
  BtnType,
  UserInline,
  Note,
  DatePiker,
  State,
  Loading,
} from "../../../../primitives";
import AddNotesComponent from "./addNotes/addNotes.component";
import { projectTaskAssigmentUpdate } from "../../companies/companies.action";
import { Icon, mdSize } from "../../../../../common/icon";
import { SelectProjectUser } from "../../users";
import DocumentListComponent from "./documentList";
import { useS3FileUpload, useModelPopup } from "../../../../../common/hooks";
import LinearProgressWithLabel from "../../../../../common/components/linearProgressWithLabel";

import {
  projectTaskNotesDelete,
  projectTaskNotesList,
  projectTaskDocumentAdd,
  projectTaskDocumentGet,
} from "../tasks.action";

const TaskInfoComponent = (props) => {
  const {
    assignmentId,
    task,
    assignment = {},
    assigned_to,
    patientOrg,
  } = props;
  //TODO we have simmilar component
  console.log("--------check for deletions-");
  const history = useHistory();
  const dispatch = useDispatch();
  const [isDateEditMode, setDateEditMode] = useState(false);
  const [assigned, setAssigned] = useState(null);
  const [dueDate, setDueDate] = useState();
  const [noteList, setNoteList] = useState([]);
  const [documentList, setDocumentList] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const [loadingDocuments, setLoadingDocuments] = useState(false);
  const [currentAssignmentId, setCurrentAssignmentId] = useState(null);
  const [uploadValues, setUploadValues] = useState([]);

  const { fileUpload } = useS3FileUpload();
  const popup = useModelPopup();
  const [selectedNote, setSelectedNote] = useState();

  const {
    authReducer: { session },
    councilReducer: { selectedCouncil },
    projectsReducer: {
      projectReducer: { selectedProject },
      taskReducer: { taskNotes, documents },
    },
  } = useSelector((state) => state);

  useEffect(() => {
    if (assignmentId !== currentAssignmentId && assignment) {
      setCurrentAssignmentId(assignmentId);

      // reset previous selected due date from previous task if in current one
      // due date isn't selected
      if (!assignment.due_date) {
        setDueDate(null);
      }
    }

    return () => null;
  }, [assignmentId, assignment]);

  React.useMemo(() => {
    if (selectedProject && assignmentId) {
      dispatch(
        projectTaskNotesList({
          projectId: selectedProject.id,
          assignmentId,
          enqueueSnackbar,
        })
      );
      dispatch(
        projectTaskDocumentGet({
          projectId: selectedProject.id,
          assignmentId,
          enqueueSnackbar,
        })
      );
    }
  }, [selectedProject && selectedProject.id, assignmentId]);

  useEffect(() => {
    if (taskNotes[assignmentId]) setNoteList(taskNotes[assignmentId]);
    return () => null;
  }, [JSON.stringify(taskNotes), assignmentId]);

  useEffect(() => {
    if (documents[assignmentId]) setDocumentList(documents[assignmentId]);
    return () => null;
  }, [JSON.stringify(documents), assignmentId]);

  useEffect(() => {
    if (assigned_to && assignment) {
      setAssigned(assigned_to);
    } else {
      setAssigned(null);
    }

    return () => null;
  }, [assigned_to, assignment]);

  useEffect(() => {
    if (assignment && assignment.id) {
      setDueDate(assignment.due_date);
    }
    return () => null;
  }, [assignment]);

  const handleViewCompanyClick = () => {
    if (assignment.company) {
      history.push(
        `/companies/${assignment.company.slug || assignment.company.id}`
      );
    }

    if (assignment.gsk_patient_organization) {
      history.push(
        `/patient_organizations/${
          assignment.gsk_patient_organization.slug ||
          assignment.gsk_patient_organization.id
        }`
      );
    }

    dispatch(
      appSliderSettingSet({
        show: false,
      })
    );
  };

  const savedocument = (s3url, name) => {
    const obj = {
      projectId: selectedProject.id,
      userId: session.id,
      councilId: selectedCouncil.id,
      description: "",
      assignmentId,
      name,
      s3url,
      enqueueSnackbar,
    };
    dispatch(projectTaskDocumentAdd(obj));
  };

  const handleAddDocumentClick = async (FileObject) => {
    const file = FileObject;
    const pathname = "documents/";
    const { name } = file;
    setLoadingDocuments(true);
    await fileUpload(file, pathname, setUploadValues).then((res) => {
      if (res && res.location) {
        savedocument(res.location, name);
        setLoadingDocuments(false);
        setUploadValues([]);
      }
    });
  };

  const handleAssingUserClick = () => {
    popup.show({
      title: "Choose Member",
      component: <SelectProjectUser callBack={handleUserChange} />,
    });
  };

  const handleUserChange = (val) => {
    popup.hide();
    task.assigned_to = val.id;
    setAssigned(val);
    updateCompanyTask();
  };

  const handleDueDateChange = (date) => {
    assignment.due_date = date;
    setDueDate(date);
    updateCompanyTask();
    setDateEditMode(false);
  };

  const getFlag = () => {
    if (dueDate && assignment.due_date) {
      return "assigned_to";
    }
    if (assigned && assignment.assigned_to) {
      return "due_date";
    }
  };

  const updateCompanyTask = () => {
    dispatch(
      projectTaskAssigmentUpdate({
        assignmentId,
        completed: assignment?.completed_on,
        companyId: assignment?.company?.id,
        flag: getFlag(),
        gskPatientOrganizationId: assignment?.gsk_patient_organization?.id,
        assignedTo: task?.assigned_to,
        stageId: assignment?.stage?.id,
        dueOn: assignment?.due_date,
        gsk: patientOrg,
        patient_org: patientOrg,
        enqueueSnackbar,
      })
    );
  };

  const handleMoreOptionClick = (value, note) => {
    switch (value) {
      case "remove":
        dispatch(
          projectTaskNotesDelete({
            noteId: note.id,
            assignmentId,
            enqueueSnackbar,
          })
        );
        break;
      case "edit":
        setSelectedNote({ id: note.id, note: note.description });
        break;
      default:
        break;
    }
  };

  const onDateModeEdit = () => {
    // assignment.due_date = null;
    setDueDate(null);
    setDateEditMode(!isDateEditMode);
  };

  return (
    <div className={styles.taskInfoWrp}>
      {assignment &&
      (assignment.company || assignment.gsk_patient_organization) ? (
        <div className={styles.companyWrp}>
          <div className={styles.companyCon}>
            {assignment && assignment.company && assignment.company.logo && (
              <div className={styles.companyIcon}>
                <img
                  src={assignment.company.logo}
                  alt={assignment.company.name}
                />
              </div>
            )}
            {assignment &&
              assignment.gsk_patient_organization &&
              assignment.gsk_patient_organization.logo && (
                <div className={styles.companyIcon}>
                  <img
                    src={assignment.gsk_patient_organization.logo}
                    alt={assignment.gsk_patient_organization.name}
                  />
                </div>
              )}
            <div className={styles.companyName}>
              {assignment.company?.name ? (
                <h4 className="medium">{assignment.company.name}</h4>
              ) : (
                assignment.gsk_patient_organization?.name && (
                  <h4 className="medium">
                    {assignment.gsk_patient_organization.name}
                  </h4>
                )
              )}
            </div>
          </div>
          {assignment?.company || assignment?.gsk_patient_organization ? (
            <div className={styles.viewCompany}>
              <Button btn={BtnType.FRAME_LESS} onClick={handleViewCompanyClick}>
                {patientOrg ? "View organization" : "View company"}
              </Button>
            </div>
          ) : null}
        </div>
      ) : null}
      {task.name && <h4 className={styles.taskName}>{task.name}</h4>}
      <div className={classNames(styles.line, styles.first)}>
        <label className={styles.label}>Task Stage</label>
        <div className={styles.values}>
          {assignment && assignment.stage ? (
            <State stageId={assignment.stage.id} />
          ) : task && task.stage ? (
            <State stageId={task.stage.id} />
          ) : null}
        </div>
      </div>
      <div className={styles.line}>
        <label className={styles.label}>Assigned to</label>
        <div
          className={classNames(styles.values, styles.assign)}
          onClick={() => handleAssingUserClick()}
        >
          {assigned && (
            <UserInline userId={assigned.id} avatar={assigned.avatar} />
          )}
          <Icon {...mdSize} icon="icn-right-chevron" className={styles.icon} />
        </div>
      </div>
      <div className={styles.line}>
        <label className={styles.label}>Due Date</label>
        <div
          className={classNames(styles.values, styles.duedate)}
          onClick={() => {
            onDateModeEdit();
          }}
        >
          {!isDateEditMode ? (
            dueDate && format(new Date(dueDate), "eeee, MMM do, yyyy")
          ) : (
            <DatePiker
              value={dueDate}
              onChange={handleDueDateChange}
              className={styles.duedateInner}
            />
          )}
          <Icon {...mdSize} icon="icn-edit-button" className={styles.icon} />
        </div>
      </div>
      <div className={styles.line}>
        <label className={styles.label}>Documents</label>
        <div className={styles.documentWrp}>
          <DocumentListComponent
            assignmentId={assignmentId}
            documentList={documentList}
            setLoadingDocuments={setLoadingDocuments}
          />
          <div className={styles.documentAdd}>
            <FilePicker
              // extensions={['pdf']}
              maxSize={500}
              onChange={(FileObject) => {
                handleAddDocumentClick(FileObject);
              }}
              onError={(errMsg) => {
                enqueueSnackbar(
                  "We could not upload your document because your file size is too big. Please make sure the file is less than 500 MB",
                  {
                    variant: "error",
                  }
                );
              }}
            >
              {loadingDocuments ? (
                <>
                  <Loading />
                  <LinearProgressWithLabel
                    value={uploadValues[0]?.progress || 0}
                  />{" "}
                </>
              ) : (
                <Button btn={BtnType.FRAME_LESS}>Add Document</Button>
              )}
            </FilePicker>
            {/* <S3Uploader
    buttonName="Upload File"
    bucketRegion="us-west-2"
    albumBucketName="traction-staging"
    IdentityPoolId="us-east-1:2fc911ef-0679"
    handleFile={this.handleFile}
  /> */}
          </div>
        </div>
      </div>
      <div className={classNames(styles.line, styles.notesWrp)}>
        <label className={styles.label}>Notes</label>
        <div className={styles.notesCon}>
          {noteList.map((note) => (
            <Note
              key={note.id}
              note={note}
              handleMoreOptionClick={(val) => handleMoreOptionClick(val, note)}
            />
          ))}
        </div>
      </div>
      <div className={styles.addNoteWrp}>
        <AddNotesComponent
          task={task}
          assignmentId={assignmentId}
          selectedNote={selectedNote}
        />
      </div>
    </div>
  );
};

export default React.memo(TaskInfoComponent);
